import React from 'react';
import RichTextRenderer from './RichTextRenderer';
import CancelIcon from '@material-ui/icons/Cancel';

import './DriscollsBanner.css';
import { IconButton } from '@material-ui/core';

const DriscollsBanner = (props) => {
  const {
    content,
    onClose,
    isDismissible,
    bgColor = props.color || 'information',
    className = '',
  } = props;

  return (
    <div
      className={`hContainer noPadding bannerStyle ${bgColor} ${className}`}>
      <div  className={`hContainer noPadding bannerBody`}>
        <div className={`vContainer`}>
          <RichTextRenderer content={content} />
        </div>
      </div>
      {isDismissible && (
        <IconButton
          size="small"
          className="bannerCloseBtn"
          noStyle
          onClick={onClose}
        >
          <CancelIcon />
        </IconButton>
      )}
    </div>
  );
};

export default DriscollsBanner;